import React from "react";
import ReactGA from "react-ga4";
import { Link, useNavigate } from "react-router-dom";

import { StyledOrangeButton } from "./styled";

export function OrangeButton(props) {
  const navigate = useNavigate();

  const handleOnClick = (url) => {
    ReactGA.event({
      category: `tlačítko - ${props.url}`,
      action: `${props.url}`,
    });

    navigate(url);
  };

  return (
    <Link to={props.url} onClick={() => handleOnClick(props.url)}>
      <StyledOrangeButton variant="outlined" shake={props.shake} style={props.style}>
        {props.text}
      </StyledOrangeButton>
    </Link>
  );
}
